import styled from "styled-components";
import CustomCheckbox from "../helperComponents/CustomCheckbox";

import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
  /* justify-content: center; */
  /* align-items: center; */
  flex-wrap: wrap;
`;

export default function ExportFieldsSelector({ fieldsList, value, onChange }) {
  const { t } = useTranslation();

  return (
    <Container>
      {fieldsList.map((item) => {
        return (
          <CustomCheckbox
            label={t(item)}
            value={value.includes(item)}
            onChange={() => {
              if (value.includes(item)) {
                let newValue = [...value];
                let index = newValue.indexOf(item);
                newValue.splice(index, 1);
                onChange(newValue);
              } else {
                let newValue = [...value];
                newValue.push(item);
                onChange(newValue);
              }
            }}
          />
        );
      })}
    </Container>
  );
}
